<div class="min-h-screen bg-gray-50 flex items-center justify-center px-4">
  <div class="w-full max-w-md">
    <div class="text-center mb-8">
      <h1 class="text-3xl font-bold text-primary">DigiHR</h1>
      <p class="text-gray-500 mt-2">Human Resource Management System</p>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
